import { render } from "./ItemsPerPageSelect.vue?vue&type=template&id=e510ec04"
import script from "./ItemsPerPageSelect.vue?vue&type=script&lang=js"
export * from "./ItemsPerPageSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__